import React, { useEffect, useState } from 'react';
import { Button, Col, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import t, { partial } from '../../../util/translation/translation';
import Api from '../../../util/api';

const GoalSponsor = () => {
  const ct = partial('Category');
  const s = partial('shared');
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(undefined);
  const [settings, setSettings] = useState([]);
  const [sponsorUrl, setSponsorUrl] = useState();

  const fetchSettings = async (comps) => {
    const { data: resSettings } =
      await Api.club.getSettingsByKey('MatchinfoSponsorId');
    setSettings(resSettings);
    if (resSettings.length > 0) {
      const foundSponsor = comps.find(
        (company) =>
          company.value ===
          resSettings.find((setting) => setting.key === 'MatchinfoSponsorId')
            ?.value
      );
      setSelectedCompanyId(foundSponsor);
    }
  };
  useEffect(() => {
    const fetchCompanies = async () => {
      const clubCompanies = await Api.companies.getClubCompanies();
      const mappedCompanies = clubCompanies
        .filter((item) => item.images.appTicketImage)
        .map((company) => ({
          label: company.name,
          value: company.id,
          image: company.images.appTicketImage,
        }));
      fetchSettings(mappedCompanies);
      setCompanies(mappedCompanies);
    };
    fetchCompanies();
  }, []);

  useEffect(() => {
    setSponsorUrl(selectedCompanyId?.image);
  }, [selectedCompanyId]);
  const handleSubmitGoalSponsor = async (selectedCompany) => {
    try {
      await Promise.all(
        settings.map((setting) => Api.club.deleteSetting(setting.id))
      );
      if (selectedCompany) {
        const payload = {
          key: 'MatchinfoSponsorId',
          value: selectedCompany.value,
        };
        await Api.club.createSetting(payload);
        await fetchSettings(companies);
        toast.success(`${s('created')}`);
      } else {
        await fetchSettings(companies);
        toast.success(`${s('removed')}`);
      }
    } catch (err) {
      toast.error(err || `${s('somethingWentWrong')}`);
    }
  };
  return (
    <div>
      <div className="form__form-group mx-2">
        <span className="form-header">{s('company')}</span>
        <Select
          placeholder={t('EventParticipantsPage.chooseCompany')}
          options={companies}
          value={selectedCompanyId}
          onChange={setSelectedCompanyId}
        />
        <small className="form-subtitle">
          Only companies with ticket sponsor image is visible in the list
        </small>
      </div>
      {sponsorUrl && (
        <div className="dropzone--container dropzone dropzone--single">
          <div className="dropzone__img">
            <img src={sponsorUrl} alt="drop-img" />
          </div>
        </div>
      )}
      <Col md={12}>
        <Button
          onClick={() => handleSubmitGoalSponsor(selectedCompanyId)}
          color="primary"
        >
          {s('save')}
        </Button>
      </Col>
    </div>
  );
};

export default GoalSponsor;
